import BaseComponent from '../base_component/base_component'

export default class Team extends BaseComponent {
    constructor(id: number, component_name: string, options: any, extra_params: {}) {
        super(id, component_name, options, extra_params);
    }

    showPopup(id) {
        $(`#team-member-popup-overlay-${id}`).show()
        $(`#team-member-popup-${id}`).show('fast')
    }

    hidePopup(id) {
        $(`#team-member-popup-overlay-${id}`).hide()
        $(`#team-member-popup-${id}`).hide('fast')
    }
}
